import { useState, useEffect } from "react";
import { useGetAllUserQuery } from "src/services/UserServices";

export const useGeeksdoorUsers = () => {
  const [geeksdoorUser, setGeeksdoorUser] = useState<any[]>([]);
  const [isDataLoading, setIsDataLoading] = useState(true);

  const { data, isLoading, isFetching } = useGetAllUserQuery("");

  useEffect(() => {
    if (isLoading || isFetching) {
      setIsDataLoading(true);
    } else {
      const result: any[] = data?.data;
      setGeeksdoorUser(result || []);
      setIsDataLoading(false);
    }
  }, [data, isLoading, isFetching]);

  return { geeksdoorUser, isDataLoading };
};
